/**
 * Read a CSS custom property from :root.
 * Use this for JS APIs that need a concrete color (wavesurfer, Notification,
 * canvas) instead of hardcoding hex values that break in dark theme.
 */
export function cssToken(name: string, fallback = ""): string {
    if (typeof document === "undefined") return fallback;
    const value = getComputedStyle(document.documentElement)
        .getPropertyValue(name)
        .trim();
    return value || fallback;
}
